/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NrInputs */

const en__field_nr = /** @type {(inputs: _Field_NrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nr.`)
};

const de__field_nr = /** @type {(inputs: _Field_NrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nr.`)
};

/**
* | output |
* | --- |
* | "nr." |
*
* @param {_Field_NrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_nr = /** @type {((inputs?: _Field_NrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_nr(inputs)
	return de__field_nr(inputs)
});